import React from 'react';

export const StoreContext = React.createContext<any>(null);

export const StoreProvider = ({ value, children }) => {
  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};
